<div class="container-fluid mt-3">

  <div class="row mb-2">
    <div class="col-12 col-md-4">
      <label>Search (url / title)</label>
      <input type="text" class="form-control" [ngModel]="q" (ngModelChange)="q = $event; onFilterChange()" (keyup.enter)="search()" placeholder="start typing to search..." />
    </div>
    <div class="col-6 col-md-2">
      <label>Device</label>
      <select class="form-control" [ngModel]="device" (ngModelChange)="device = $event; onFilterChange()">
        <option value="">any</option>
        @for (d of devices; track d) {
          <option [value]="d">{{d}}</option>
        }
      </select>
    </div>
    <div class="col-6 col-md-2 form-check mt-4">
      <input type="checkbox" class="form-check-input" id="includeIncognito" [ngModel]="includeIncognito" (ngModelChange)="includeIncognito = $event; onFilterChange()" />
      <label class="form-check-label" for="includeIncognito">include incognito</label>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-6 col-md-2">
      <label>Created from</label>
      <input type="datetime-local" class="form-control" [ngModel]="createdFrom" (ngModelChange)="createdFrom = $event; onFilterChange()" />
    </div>
    <div class="col-6 col-md-2">
      <label>Created to</label>
      <input type="datetime-local" class="form-control" [ngModel]="createdTo" (ngModelChange)="createdTo = $event; onFilterChange()" />
    </div>
    <div class="col-6 col-md-2">
      <label>Updated from</label>
      <input type="datetime-local" class="form-control" [ngModel]="updatedFrom" (ngModelChange)="updatedFrom = $event; onFilterChange()" />
    </div>
    <div class="col-6 col-md-2">
      <label>Updated to</label>
      <input type="datetime-local" class="form-control" [ngModel]="updatedTo" (ngModelChange)="updatedTo = $event; onFilterChange()" />
    </div>
    <div class="col-6 col-md-2">
      <label>Closed from</label>
      <input type="datetime-local" class="form-control" [ngModel]="closedFrom" (ngModelChange)="closedFrom = $event; onFilterChange()" />
    </div>
    <div class="col-6 col-md-2">
      <label>Closed to</label>
      <input type="datetime-local" class="form-control" [ngModel]="closedTo" (ngModelChange)="closedTo = $event; onFilterChange()" />
    </div>
  </div>

  <div class="mb-3">
    <button type="button" class="btn btn-primary" (click)="search()" [disabled]="loading">Search</button>
    @if (searching) {
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="clearSearch()">Back to live view</button>
    }
  </div>

  @if (searching) {
    <div class="mb-2">
      {{results.numberOfElements}} shown / {{results.totalElements}} total
    </div>
  }

  <table class="table table-sm table-hover">
    <thead>
    <tr>
      <th>created</th>
      <th>updated</th>
      <th>closed</th>
      <th>device</th>
      <th class="max-width">url</th>
      <th class="max-width">title</th>
    </tr>
    </thead>
    <tbody>
      @for(tab of (searching ? results.content : tabs); track tab.id) {
        <tr>
          <td>{{tab.created | date:'yyyy-MM-dd HH:mm:ss' : 'Europe/Vienna' : 'en-DK'}}</td>
          <td>{{tab.lastUpdated | date:'yyyy-MM-dd HH:mm:ss' : 'Europe/Vienna' : 'en-DK'}}</td>
          <td>{{tab.closed | date:'yyyy-MM-dd HH:mm:ss' : 'Europe/Vienna' : 'en-DK'}}</td>
          <td>{{tab.installation.clientName}}</td>
          <td class="max-width"><a [href]="tab.url" target="_blank">{{tab.url}}</a></td>
          <td class="max-width">{{tab.raw.title}}</td>
        </tr>
      }
    </tbody>
  </table>

  @if (searching) {
    <div class="mb-3">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="prevPage()" [disabled]="page === 0">Prev</button>
      <span class="mx-2">page {{page + 1}} / {{results.totalPages}}</span>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="nextPage()" [disabled]="(page + 1) * size >= results.totalElements">Next</button>
    </div>
  }

</div>
